import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { communityCreatorPausePath, communityCreatorStagePath, newAccountPath } from "@travily/routes";
import { sanitizeHandle } from "@/lib/handle/sanitize-handle";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { CommunityHandleStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  handle: string | null;
  suggested_handle: string;
  profileable_id: number;
  account_id: number;
}

type FormData = {
  handle: string;
  /** Posted back so the availability check excludes the member's own handle. */
  account_id: number;
};

const CommunityHandleStep = ({
  stage_index,
  stage_order,
  handle,
  suggested_handle,
  profileable_id,
  account_id,
}: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => communityCreatorStagePath(profileable_id, stage),
      entryUrl: newAccountPath(),
      pauseUrl: communityCreatorPausePath(profileable_id),
    },
    stageName: "handle",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { handle: handle ?? suggested_handle ?? "", account_id },
  });

  const handleField = bindField("handle", {
    validateOn: "change",
    successMessage: t("common.wizard.handle.available"),
    transform: sanitizeHandle,
  });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.communities.creator.steps.handle.show.meta_title")}>
        <meta name="description" content={t("web.communities.creator.steps.handle.show.meta_description")} />
      </Head>
      <CommunityHandleStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={handleField.value}
        error={handleField.errorMessage}
        successMessage={handleField.successMessage}
        onChange={handleField.onChange}
        onBlur={handleField.onBlur}
      />
    </>
  );
};

export default CommunityHandleStep;
